import React, {useEffect} from 'react';
import {useForm} from '@inertiajs/react';
import toast from 'react-hot-toast';

function AuthForm({event, isAfter}) {
    const {data, setData, post, processing, errors} = useForm({
        email: '',
        code: '',
    })

    useEffect(() => {
        if (errors.verify) {
            toast.error(errors.verify);
        }
    }, [errors]);

    function submit(e) {
        e.preventDefault()
        if (data.code) {
            post(`/camera/events/${event.id}/verify`)
        } else {
            post(`/camera/events/${event.id}/notify`)
        }
    }

    return (
        <div>
            {!errors.verify && !errors.code ? (
                <div>
                    <h2 className="font-bold text-xl">Receive album link</h2>
                    {isAfter ? <div>
                        <p className="text-sm">Enter your email address to receive a link to the album once it reveals
                            on <span className="font-semibold">{event.reveal_at_formatted}</span>.</p>
                        <small className="text-red-500">Otherwise we won't be able to send you a link to the album once
                            it
                            reveals!</small>
                    </div> : <div>
                        <p className="text-sm">Enter your email address to receive a link to the album so you can easily
                            access it in the future.</p>
                    </div>}

                    <form onSubmit={submit}>
                        <div className="flex flex-col mt-2">
                            <label className="font-bold" htmlFor="code">Email Address</label>
                            <input
                                value={data.email}
                                onChange={e => setData('email', e.target.value)}
                                className="rounded-[10px]"
                                type="email"
                                autoComplete={"email"}
                                required
                                placeholder="Email Address" />
                            {!!errors.email && <span className="text-xs text-red-500">{errors.email}</span>}
                            <button
                                type="submit"
                                disabled={processing}
                                className="flex-wrap flex items-center justify-center shadow transition duration-300 transform px-6 py-3 font-medium text-white mt-[10px] rounded-[10px] focus:outline-none hover:shadow-md bg-primary-500 hover:bg-primary-500">
                                Notify me
                            </button>
                        </div>
                    </form>
                </div>
            ) : (
                <div>
                    <h2 className="font-bold text-xl">Looks like you already have an account</h2>
                    <p className="text-sm">We have just emailed you a verification code. Please enter it down below.</p>
                    <form onSubmit={submit}>
                        <div className="flex flex-col mt-2">
                            <label className="font-bold" htmlFor="code">Verification code</label>
                            <input
                                required
                                autoFocus={true}
                                id="code"
                                placeholder={'XXXXXX'}
                                className="rounded-[10px]"
                                type="number"
                                autoComplete="one-time-code"
                                value={data.code}
                                onChange={e => setData('code', e.target.value)}
                            />
                            <div>
                                {errors.code && <small className="text-xs text-red-500">{errors.code}</small>}
                            </div>
                            <small>We have to verify your email to continue.</small>

                            <button
                                type="submit"
                                disabled={processing}
                                className="flex-wrap flex items-center justify-center shadow transition duration-300 transform px-6 py-3 font-medium text-white mt-[10px] rounded-[10px] focus:outline-none hover:shadow-md bg-primary-500 hover:bg-primary-500">
                                Verify code
                            </button>
                        </div>
                    </form>
                </div>
            )}

        </div>
    );
}

export default AuthForm;
